export const START_TIME_ERROR = 'Star Team Number is required';
export const CODE_VALUE_REQUIRED = 'Code value is required';
export const CODE_VALUE_EXIST = 'Code value already exists.';
export const REBATE_CD_ERR = 'Please select rebate Program';
export const CUSTOM_ERR_CLUASE = 'Custom Where Clause  is required';
export const PROVIDER_ID = 'Provider ID  is required';
export const PROVIDERMESSAGE = 'No Inelgible Providers found for this Provider ID Type.';
export const FIELDMESSAGE = 'Code Value  is required';
export const ING_BE_ERR =
  'Entry cannot be deleted; period contains frozen invoice';
export const ING_CONFIRM = 'Are you sure you want to delete?';
export const ING_ERR =
  'Ineligible provider entry cannot be deleted; This period contains frozen invoice.';
export const ING_NEW_CONFIRM =
  'A Provider should only be deleted if added in error. If Provider is no longer eligible, please enter end date. Delete row';
export const ING_MSG =
  'Ineligible provider has not been entered into DRAMS. Do you want to proceed?';
export const DTRNG_MSG =
  'Date range doesn’t match Ineligible Provider table. Do you want to proceed?';
export const FUTURE_QUARTER_ERROR =
  'End quarter cannot be less than Begin Quarter.';
export const SUCCESSMESSAGE = 'Data Saved successfully';
export const SUCCESSMESSAGE_PRICE =
  'System successfully saved the information.';
export const SUCCESSMESSAGE_GENERIC =
  'System successfully saved the information.';
export const FAILED_MESSAGE_GENERIC =
  'There was an error processing the request. Please retry the transaction.';

export const NO_VALUE_RESPOSNE = 'No Value in the resposne';
export const NO_VALUE_RESPOSNE_INTEREST =
  'There is No interest found for the specified criteria';
export const ERRORMESSAGE = 'Code Value should not be empty in ';
export const ERRORMESSAGE_CODEVALUE = ' Code value already exists ';
export const SEARCH_FIELD_REQUIRED = 'Search Field is Required';
export const NAME_REQUIRED = 'Name is required.';
export const CONTACT_TYPE_REQUIRED = 'Contact Type is required.';
export const ADDRESS_LINE1_REQUIRED = 'Address Line 1 is required.';
export const CITY_REQUIRED = 'City is required.';
export const STATE_REQUIRED = 'State is required.';
export const ZIP_REQUIRED = 'Zip is required.';
export const ZIP4_REQUIRED = 'Invalid Zip+4.';
export const PHONE_REQUIRED = 'Phone Number is required.';
export const FAX_REQUIRED = 'Fax is required & must be of 10 digits';
export const PHONE_INVALID_ERROR = 'Invalid Phone Number.';
export const EMAIL_REQUIRED = 'Email Address is required.';
export const EMAIL_INVALID = 'Invalid Email Address.';
export const START_DATE_REQUIRED = 'Start Date is required.';
export const MANUFACTURER_ID_REQUIRED = 'Manufacturer ID is required.';
export const MAILING_DATE_REQUIRED = 'You must enter a mailing date';
export const CONTACT_TYPE_REQ = 'Contact Type Cd is required.';
export const MFG_NO_CONTRACT_USING_CONTACT_ERROR =
  'There are no contracts that are using this contact.';

export const MANUFACTURER_ID_ONLY_NUMBER =
  'Please enter a valid Governmental Manufacturer ID. Governmental Manufacturer ID should be numeric.';
export const MANUFACTURER_NAME_REQUIRED = 'Manufacturer Name is required.';
export const MFG_BANKRUPTCY_TYPE_REQUIRED = 'Bankruptcy Type is required.';
export const MANUFACTURER_ID_INVALID_FORMAT_ERROR =
  'Please enter a valid Governmental Manufacturer ID.';
export const MFG_BANKRUPTCY_OVERLAPPING_ERROR =
  'Bankruptcy Code overlaps between row';
export const MANUFACTURER_ID_COM_INVALID_FORMAT_ERROR =
  'Please enter a valid Commercial Manufacturer ID.';

export const ERRORMESSAGE_NOT_A_NUMBER =
  'Display sequence should be number or null';

export const PLAN_TYPE_REQUIRED = 'Plan Type is required.';
export const PLAN_TYPE_DESC_REQUIRED = 'Plan Type Description is Required.';
export const REBATE_PGM_CODE_DESC_REQUIRED =
  'Rebate Program Code Decription is required.';
export const DRUG_FAMILY_NAME_REQUIRED = 'Drug Family Name is required.';
export const DRUG_FAMILY_DESC_REQUIRED = 'Drug Family Description is required.';

// Excluded NDCs-----
export const ERRORMESSAGE_NDC_NOT_EMPTY =
  'You have not selected any NDC for further processing.';
export const ERRORMESSAGE_NDC_MAN_NOT_EMPTY =
  'You have not selected any NDCs to view the calculated interest.';
export const ERRORMESSAGE_MFR_NOT_EMPTY =
  'You have not selected any Manufacturer to view the calculated interest.';
export const REBATE_SELECT = 'Rebate Program is required.';
export const END_QTR_ERROR = 'End quarter cannot be less than Begin quarter.';
export const NDC_NOT_FOUND = 'NDC searched by the user is not an Excluded NDC.';
export const DATE_QTR_FORMAT_ERROR =
  'Please enter a date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const QUARTER_FORMAT_ERROR =
  'Please enter a valid quarter and year in “#Q##” or “#Q####” format. Example: ‘1Q98’ or ‘1Q1998.';
export const DATE_INVALID_FORMAT_ERROR =
  'Please enter the date in MM/DD/YYYY format where year is 2 or 4 digits.';
export const MFG_CONTACT_DETAILS_ERROR =
  'Please add at least one Contact Information for the manufacturer.';
export const MFG_BANKRUPTCY_END_DATE_ERROR =
  "The End Date can't be less than or equal to the Start Date for Manufacturer Bankruptcy.";
export const MFG_LABELER_END_DATE_ERROR =
  "The End Date can't be less than the Start Date for Manufacturer Labeler.";
export const MFG_START_DATE_ERROR = "Start Date can't be less than 01/01/1991.";
export const NO_DATA_FOUND_ERROR = 'No data found for the filter selection.';
export const DRUG_SELECTION_ERR = 'Please select a drug(s).';

// Unit_conversion---
export const ERRORMESSAGE_NDC_WHEN_EMPTY = 'Please select a drug to search.';
export const ERRORMESSAGE_NDC_NOT_EMPTY_FOR_UNIT_CONVERSION =
  'Please select a drug to search.';
export const ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION =
  'Please select a manufacturer or All Manufacturers.';
export const ERRORMESSAGE_SELECT_CODE_VALUE = 'Please Select a Dispute Code.';
export const ERRORMESSAGE_SELECT_CLASS_VALUE =
  'Please Select Therapeutic Class.';
export const END_QTR_ERROR_UC =
  'End quarter cannot be less than Begin quarter.';
export const BUILD_UNIT_FCTR_NULL_UC =
  'Billed Unit Factor must be entered for Row ';
export const CMS_UNIT_FCTR_NULL_UC = 'CMS Unit Factor must be entered for Row ';
export const CLAIM_CATEGORY_NULL_UC =
  'Claim category must be selected for Row ';
export const REBATE_PROGRAM_NULL_UC =
  'Rebate Program must be selected for Row ';
export const START_QTR_UC = 'Start Quarter must be entered for the row ';
export const STRT_END_EQUAL_QTR_ERROR_UC =
  'Start quarter cannot be equal to end quarter.';
export const OVERLAP_LOGIC_UC =
  'An NDC may not have multiple unit conversions with the same billed factor that would apply to the same claim. Line ## and line ## violate these criteria.';
export const QUARTER_FORMAT_ERROR_UC =
  'Please enter a valid quarter and year in “#Q##” or “#Q####” format. Example: ‘1Q98’ or ‘1Q1998’.';
export const NDC_FOR_UC_NOT = 'Enter a valid NDC Name.';
export const NDC_FOR_STC_NOT = 'Please enter a valid NDC name.';
export const NDC_CODE_FOR_STC_NOT =
  'Please enter NDC in the format XXXXX-XXXX-XX or XXXXXXXXXXX.';
export const NDC_ALREADY_FOR_STC_NOT = 'NDC already selected.';
export const VALID_NDC_MSG_UC = 'Please Enter valid NDCs. E.g. xxxxx-xxxx-xx';
export const VALID_NDC_MSG =
  'Please Enter valid NDCs. e.g. xxxxx-xxxx-xx or xxxxxxxxxxx';
export const STRT_QTR_ERROR_UC =
  'End quarter cannot be less than Begin Quarter.';
export const MNFC_NDC_ERROR_MSG =
  'No results found for the search criteria selected.';
export const SAVE_NDC = 'System successfully saved the information.';
export const SUCCESS_MESSAGE = 'System successfully saved the information.';
export const SAVE_ERROR_NDC = 'Something went wrong, please try again later.';
export const END_QTR_UC = 'End Quarter must be entered for the Row';
export const SELECT_NDC_NAMES = 'Please select from the drug names';

export const ERR_PAGINATE_VALUE = 'Please enter some valid input.';
export const ERR_NDC_NAME = "NDC name doesn't exist.";
export const ERR_NDC_NDC = "NDC doesn't exist.";
export const ERR_NDC_NDC_HISTORY = 'This is not existing NDC.';
export const DEL_NOT_ENABLED =
  'Cannot Delete Unit Conversion, Unit conversion has been used, You should specify an End Quarter instead';
export const FUTURE_DATE_ERROR = 'From Date cannot be in the future';
export const MINIMUM_START_DATE = 'Start date cannot be less than 01/01/1991.';
export const MINIMUM_FORM_DATE = 'From date cannot be less than 01/01/1991.';
export const MINIMUM_START_DATE_VALUE = '01/01/1991';
export const REQUEST_DATE_INVALID_FORMAT =
  'Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 4Q1997.';
export const REQUEST_DATE_INVALID_FORMAT_CBI =
  'Please enter a valid quarter and year in “#Q##” or “#Q####” format. Example: ‘1Q98’ or ‘1Q1998’.';
export const DATE_RANGE_ERR = 'End date cannot be less than Begin Date';
export const ERRMSG_NOT_SELECTED_NDC =
  'You have not selected any NDC to process.';
export const ERRMSG_NO_NDC_REQUEST_CLAIM_AUDIT =
  'You have not selected any NDC to process.';
export const ERRMSG_NOT_SELECTED_LABELER =
  'You have not selected any Labeler to process.';
export const ERRMSG_NOT_LABELER = 'Please select a Labeler.';
export const ERROR_DATE_FORMAT =
  'Please enter a date in the form in MM/DD/YEAR where year is 2 or 4 digits.';
export const FROM_DATE_LESS_THAN_TO_DATE_ERROR =
  'From Date should be less than To Date.';
export const TO_DATE_FUTURE_ERROR = 'To Date cannot be in the future.';
export const ENTER_NUMERIC_ONLY_ERROR = (fieldName) =>
  `Please enter a numeric value in ${fieldName}.`;
export const FROM_DATE_FUTURE_ERROR = 'From Date cannot be in the future.';
export const FROM_DATE_BACKWARD_ERROR =
  'From Date cannot be less than 01/01/1991.';
export const TO_DATE_BACKWARD_ERROR = 'To Date cannot be less than 01/01/1991.';
export const DATE_BACKWARD_ERROR = 'Date cannot be less than 01/01/1991.';
export const DATE_FUTURE_ERROR = ' Batch Date cannot be in the future.';
export const BATCH_NUMBER_ALREADY_EXISTS =
  'This batch number already exists.Please enter a different batch number.';
export const BATCH_NUMBER_NOT_NULL = 'Batch Number is required.';
export const CHECK_PAYEE_CD = 'CHECK_PAYEE_CD';
export const BATCH_DATE_NOT_NULL = 'Batch Date is required.';
export const TOT_CHECKS_NOT_NULL = 'Total Number of Checks is required.';
export const TOT_AMT_CHECKS_NOT_NULL = 'Total Amount of Checks is required.';
export const CHECK_PAYEE_NOT_NULL = 'Check Payee is required.';
export const ERR_UC_OVERLAPPING_PROCEDURE_CD_MESSAGE =
  'An NDC may not have multiple overlapping unit conversions for category ';
export const ERR_UC_OVERLAP_MESSAGE =
  'An NDC may not have multiple unit conversions with the same billed factor that would apply to the same claim. Lines ';
export const ERR_UC_OVERLAP_HCPCS_MESSAGE =
  'An NDC may not have multiple overlapping unit conversions for category modified/current row claim category value where there is at least one with a procedure code and one without. Lines ';
export const ERR_SELECT_NDC_REMOVE = 'Atleast one NDC must be selected.';
export const ERR_NDC_REMOVE = 'Nothing to remove.';
export const NDC_ALREADY_ADDED = 'NDC already added';
export const PAID_DATE_ERR = 'From Date/Qtr. is required.';
export const QTR_VALIDATION_ERR =
  'End Quarter cannot be less than Begin Quarter.';
// Log check
export const RECEIVED_DATE_REQUIRED =
  'Received Date is required for Check Log Number';
export const RECEIVED_DATE_LESS_THAN_ERROR =
  "Received Date can't be less than 01/01/1991 for Check Log Number";
export const BATCH_DATE_LESS_THAN_ERROR =
  "Batch Date can't be less than 01/01/1991 for Check Log Number";
export const CHECK_DATE_LESS_THAN_ERROR =
  "Check Date can't be less than 01/01/1991 for Check Log Number";
export const POSTMARK_DATE_LESS_THAN_ERROR =
  "Postmark/ EFT Transmittal Date can't be less than 01/01/1991 for Check Log Number";

export const CHECK_ISSUE_REQUIRED =
  'Check Issuer is required for Check Log Number';
export const CHECK_AMOUNT_REQUIRED =
  'Check Amount is required for Check Log Number';
export const CHECK_AMOUNT_ALLOW_NUMBER_REQUIRED =
  'Check amount must be number for Check Log Number';
export const CHECK_AMOUNT_NON_ZERO_REQUIRED =
  'Check amount must be non-zero for Check Log Number';
export const CHECK_PAYEE_REQUIRED =
  'Check Payee is required for Check Log Number';
export const FUTURE_DATE_NOT_ALLOW_ERROR =
  'cannot be a future date for Check Log Number ';
export const WITHOUT_SAVE_ADD_COMMENT_ERROR =
  'You must save the check data before adding the comment.';
// Create Letter
export const TEMPLATE_NAME_REQUIRED_ERROR = 'Please select a Template Name.';
// Letter Template
export const TEMPLATE_NAME_REQUIRED = 'You must give this template a name.';
export const TEMPLATE_TYPE_REQUIRED = 'You must select a template type.';
export const TEMPLATE_DESCRIPTION_REQUIRED =
  'Please enter a description for this template.';
export const WINDOW_VALIDATION = 'Item doesn’t pass the validation test';
export const EMAIL_SUBJECT_REQUIRED =
  'Email Subject is required for the selected delivery medium.';
export const PREVIOUS_TEMPLATE_VERSION_NOT = 'This template has no history.';
export const MERGE_FIELD_ITEM_REQUIRED =
  'Please select merge field item(s) to add.';
export const SELECT_AN_TEMPLATE = 'Please select an template from dropdown.';
export const ONLY_ONE_FREE_FROM_TEXT =
  'Only one Free Form Text Input field is allowed.';
export const ONE_LETTER_FOR_COVER =
  'There could only be one Cover Letter Template for a Rebate program. Do you like to open an existing one?';
export const AUTO_SEND_IND_FOR_DISPUTE =
  'The current detailed dispute template already has auto send indicator set.';
export const CHECK_DUPLICATE_TEMPLATE_NAME =
  'A template exists with this Template name. Please enter a different template name.';
export const SAVE_FIRST_BEFORE_COPY =
  'You must save the template first before copying.';
export const SAVE_BEFORE_PREVIEW =
  'Need to save in order to preview. Do you want to continue?';
export const NOT_ANY_SELECTED_MERGE_FIELD =
  'Please save the template before editing the merge field.';
export const PREVIEW_ERROR_IFNOT =
  'Error encountered while generating the invoice header.';
export const SAVE_BEFORE_COMMENT =
  'You must save the letter data before adding the comment.';

export const COMMENT_SUBJECT = 'Subject is required.';

export const SUCCESS_MSG = 'SUCESS';
export const STATUS_MSG = '001';

// checkByInvoice
export const QUARTER_VALUE_REQUIRED = 'Quarter is required.';
export const QUARTER_DATE_REQUIRED = 'A date quarter is required.';
export const QUARTER_VALUE_REQUIRED_RANGE =
  'From Quarter is required in Selected Range.';
export const REBATE_PROGRAM_REQUIRED = 'Rebate Program is required.';
export const NDC_LIMIT_TO_1000 =
  'Maximum NDC to pass is 1000, you have selected more. Would you like to continue processing the first 1000?';
export const MANUFACTURE_NO_REQUIRED =
  'Number of Manufacturers to display are required.';
export const REBATE_REPORTING_REQUIRED = 'CMS Reporting Group is required.';
export const CLIENT_ID_REQUIRED = 'Client id is required.';
export const ASSIGNMENT_REQUIRED = 'Assignment is required.';
export const NO_DATA_TO_DISPLAY = 'No data found for the selection.';
export const NO_DATA_FOR_FILTER_SELECT =
  'No data found for the filter selection.';
export const NO_RESULT_FOUND_ERROR =
  'No results found for the search criteria selected.';
export const PREVIOUS_CLAIM = 'The claim has no previous claim.';
export const REPLACE_CLAIM = 'The claim is not replaced by another.';
export const REVERSING_CLAIM = 'The claim is not reversed by another.';
export const CLAIM_AUDITS =
  'There are no Audits that matches the Specified criteria.';
// Generate Collection Letter
export const PERCENT_PAID_REQUIRED = 'Percent Paid is required.';
export const AMOUNT_OWED_REQUIRED = 'Amount Owed is required.';
export const TEMPLATE_REQUIRED = 'Template Name is required.';
// Request Mailing Labels
export const ADDRESS_TYPE_REQUIRED = 'Address Type is required.';
export const COPIES_REQUIRED = 'Copies is required.';
export const REBATE_PROGRAM_REQUIRED_REQ = 'Rebate Program is required.';

export const DATE_INVALID_REQUEST_MAILING =
  'Please enter the date in MM/DD/YYYY format where year is 2 or 4 digits.';
export const SELECT_MANUFACTURER = 'Please select a Manufacturer.';
export const REQ_MAILING_NO_MANUFACTURER =
  'There are no manufacturers that fit those criteria.';
export const PRINT_REQ_MAILING = 'You are about to print';
export const REQ_MAILING_CONTINUE = 'labels. Continue?';
export const DRUG_FAMILY_ID = 'Family id is Required.';
export const DRUG_FAMILY = 'Family name is Required.';
export const DRUG_DESCRIPTION = 'Description is Required.';
export const CALCULATED_QUATER_REQUIRED = 'Calculated Quarter is required.';
export const PRICE_TYPE_REQUIRED = 'Price Type is required.';
// Drug Family
export const DATE_INVALID = 'Please enter valid date.';
export const MAILING_DATE_INVALID = 'Mailing date entered is invalid.';
export const DATE_FUTURE_INVALID = 'Future date entered is invalid.';
export const DATE_PAST_INVALID = 'Past date entered is invalid.';
export const PERCENT_SUBMITTED_AMOUNT_REQ =
  'Percent submitted amount is required.';
export const PERCENT_ALLOWED_AMOUNT_REQ = 'Percent allowed amount is required.';
export const PERCENT_AVERAGE_UNITS_REQ = 'Percent average units is required.';
export const PERCENT_PRIOR_QUARTER_REQ = 'Percent prior quarter is required.';
export const PERCENT_REIMBURSED_AMOUNT_REQ =
  'Percent reimbursed amount is required.';
export const THRESHOLD_AMOUNT_REQ = 'Threshold amount is required.';
export const NO_DRUG_RETRIEVED =
  'No drug retrieved. Please modify search criteria';
export const CUSTOM_MSG_SEARCH_DRUG = 'Please enter ';
export const NO_CORRECT_ID =
  'Manufacturer or specific therapeutic class not found.';

// labeler differences
export const NO_DIFFERENCE_IN_LABELER = 'No Difference(s) to report.';
export const INPUT_VALUE_GRETER_THAN_TOTAL_COUNT =
  'Please input a number less than the total page.';
// Invoice Audits
export const NOT_SELECTED_ROW = 'Please select a manufacturer.';
export const ERROR_COUNT_LESS_THAN_25 =
  'The following problems were found with the requested selections.';
export const ERROR_COUNT_GREATER_THAN_25 =
  'There are too many problems with requested selection to continue.';
export const MAX_THRESHOLD_ALLOWED =
  'The Invoice mail threshold is greater than $50 maximum allowed by CMS.';
export const MAX_RETAINED_QTR = 'Send All Retained Quarter must be 0 or 1-4.';
export const HOLIDAY_DT_REQ = 'Holiday Date is required.';
export const HOLIDAY_DESC_REQ = 'Holiday Description is required in row #';
export const DUPLICATE_HOLIDAY_DATE_ERROR =
  'Holiday date already exists at row #';
export const FILE_TYPE_REQ = 'File Type is required';
export const ACCOUNT_NUMBER_REQ = 'Account number is required';
export const SPEC_THERA_CD_REQ = 'Spec Thera Code is required.';
export const BUDGET_REF_REQ = 'Budget Reference is required ';
export const CLASS_FIELD_REQ = 'Class field is required ';
export const THRESHOLD_NO_OF_UNITS_REQ = 'Threshold number of units required.';
export const MAIL_ORDER_MULTIPLIER_REQ = 'Mail Order Multiplier required.';
export const NDC_NOT_FOUND_STC = 'NDC not found.';
export const NDC_ATLEAST_SELECT_ONE = 'Atleast one NDC must be selected.';
export const PAGINATION_EMPTY_ERR = 'Please input a numeric value only.';
export const PAGINATION_NEGATIVE_ERR = 'Please input a positive number.';
export const PAGINATION_OVER_TOTAL_ERR =
  'Please input a number less than total page.';
// Contract
export const CORPORATION_REQUIRED = 'Corporation Name is Required';
export const CONTACT_TYPE_CODE_REQUIRED = 'Contact Type Code is Required';
export const CONTRACT_DESCRIPTION = 'Description is Required';
export const CONTRACT_REQUIRED = 'Please enter a Contract Name';
export const ASSIGN_STARTDATE_ERROR =
  'Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits.';
export const START_DATE_INVALID =
  'Please enter the start date in MM/DD/YYYY format where year is 2 or 4 digits.';
export const END_DATE_INVALID =
  'Please enter the end date in MM/DD/YYYY format where year is 2 or 4 digits.';
export const WRITE_OFF_DATE_INVALID =
  'Please enter the write off date in MM/DD/YYYY format where year is 2 or 4 digits.';
// CMSMisMatch
export const MUST_CHECK_ANY_CHECKBOX =
  'You must check one of the invoice checkboxes.';
export const QUARTER_REQUIRED = 'Quarter is required.';
export const REBATE_PROG_REQUIRED = 'Rebate Program is required.';
export const STARTDATE_REQUIRED = 'Start Date is Required.';
export const ENDDATE_REQUIRED = 'End Date is Required.';
export const CHECK_LOG_NUM_REQ = 'Check Log Number is required.';
export const CHOOSE_BY_REQ = 'Quarter Range is required.';
// drug Family
// Log check
export const START_DATE_REQUIRED_DRUG_FAMILY = 'Start Date is required for Row';
export const HOLIDAY_DATE_REQUIRED = 'Holiday Date is required in row #';
export const DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE =
  'Please enter the date in MM/DD/YYYY format where year is 2 or 4 digits in row #';
export const DATE_INVALID_FORMAT_ERROR_DRUG_FAMILY =
  'Please enter the date in MM/DD/YYYY format where year is 2 or 4 digits for Row';
export const END_DATE_GREATER_THAN_START_DATE_DRUG_FAMILY =
  "The End Date can't be less than the Start Date for Row";
export const MINIMUM_START_ERROR_DRUG_FAMILY =
  "Start Date can't be less than 01/01/1991 for Row";
export const MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY =
  "Holiday Date can't be less than 01/01/1991 in row #";
export const WAC_FILED_ALLOW_NUMBER = 'WAC Override Percent must be number.';
export const RUN_LATER_MESSAGE = 'Job has been submitted to run deferred.';
export const AS_OF_DATE_REQUIRED = 'As Of Date is required.';
export const MINIMUM_AS_OF_DATE = 'As Of Date cannot be less than 01/01/1991.';
export const NOT_SELECTED_ANY_MFG =
  'You have not selected any NDCs/Manufacturer to calculate interest.';
export const DELETE_CHECKLOG_COMPLETED = 'Delete Check Log Completed.';
export const DELETE_BATCH_COMPLETED = 'Delete Batch Completed.';
export const ERROR_BATCH_DELETED = 'Error while deleting batch.';
export const ERROR_DELETE_CHECKLOG = 'Error while deleting the check log.';
export const START_QUATER_REQ = 'Start Quarter is required.';
export const BEGIN_QUATER_REQ = 'Begin Quarter is required.';
export const END_QUATER_REQ = 'End Quarter is required.';
export const DATE_REQUIRED = '{d} date is required for generating {r} Report.';
export const END_DATE_PROVIDED = 'End Date must be provided.';
export const CONTRACT_START_DATE_GRT_END_DATE =
  'The Contract Start Date is Greater than the Contract End Date.';
export const COVERAGE_START_DATE_INVALID =
  'Please enter the coverage gap start date in MM/DD/YYYY format where year is 2 or 4 digits.';
export const COVERAGE_END_DATE_INVALID =
  'Please enter the coverage gap end date in MM/DD/YYYY format where year is 2 or 4 digits.';
export const COVERAGE_START_DATE_GRT_END_DATE =
  'End date should be greater than start date.';
export const DEFAULT_START_QTR = 'Default Start Quarter is required.';
export const CONTRACT_START_QTR = 'Start Quarter is required.';
export const CONTRACT_START_QUARTER_FORMAT_ERROR =
  "Please enter a valid start quarter and year in the form '#Q## or #Q####' such as '1Q98 or 3Q1997' on Row";
export const CONTRACT_END_QUARTER_FORMAT_ERROR =
  "Please enter a valid end quarter and year in the form '#Q## or #Q####' such as '1Q98 or 3Q1997' on Row";
export const CONTRACT_NOT_SELECTED_ROW = 'Please select a row.';
export const VALIDATE_QUARTER_VALUE =
  'Please enter a valid quarter and year in “#Q##” or “#Q####” format. Example: ‘1Q98’ or ‘1Q1998’.';
export const END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT =
  "The End Date can't be less than the Start Date.";
export const END_DATE_GREATER_THAN_START_DATE =
  "To date can't be less than the From date.";
export const INVALID_DATE_DURATION =
  'Date/Quarter Duration cannot exceed maximum of 4 Quarters.';
export const MINIMUM_START_ERROR_FOR_CONTRACT =
  "Start Date can't be less than 01/01/1991.";
export const MFG_ID_FOR_CONTRACT = 'Manufacturer ID is required';
export const MFG_NAME_FOR_CONTRACT = 'Manufacturer Name is required';
export const CONTACT_TYPE_CODE_FOR_CONTRACT = 'Contact Type Code is required';
export const DESCRIPTION_FOR_CONTRACT = 'Description is required';
export const MINIMUM_WRITE_DATE_ERROR_FOR_CONTRACT =
  "Write Off Date can't be less than 01/01/1991.";
export const ZIP4_REQUIRED_FOR_OTHER_CONTRACT_TAB =
  'Invalid Zip+4 for other contact.';
export const PHONE_INVALID_ERROR_FOR_OTHER_CONTRACT_TAB =
  'Invalid Phone Number for other contact.';
export const EMAIL_INVALID_FOR_OTHER_CONTRACT_TAB =
  'Invalid Email Address for other contact.';
export const ZIP4_REQUIRED_FOR_INVOICE_CONTRACT_TAB =
  'Invalid Zip+4 for invoice contact.';
export const PHONE_INVALID_ERROR_FOR_INVOICE_CONTRACT_TAB =
  'Invalid Phone Number for invoice contact.';
export const EMAIL_INVALID_FOR_INVOICE_CONTRACT_TAB =
  'Invalid Email Address for invoice contact.';
export const ZIP4_REQUIRED_FOR_DISPUTE_CONTRACT_TAB =
  'Invalid Zip+4 for invoice contact.';
export const PHONE_INVALID_ERROR_FOR_DISPUTE_CONTRACT_TAB =
  'Invalid Phone Number for invoice contact.';
export const EMAIL_INVALID_FOR_DISPUTE_CONTRACT_TAB =
  'Invalid Email Address for invoice contact.';
export const START_QUARTER_ERROR = 'Start Quarter is required on Row';
export const END_QTR_GRATER_START_QTR_ERR =
  'End Quarter cannot be less than Start Quarter on Row';
export const CONTACT_TYPE_EXISTING_DEL =
  'You cannot delete a contact type that has existing contacts';
export const DOUBLE_CLICK_GRID_MSG =
  '* On Double Click of Results, system should navigate to Detail page.';
export const SEARCH_FOR_FIELD_REQUIRED = 'Search For is Required';
export const REBATE_PROG_CD_REQ = 'Rebate Program Code is required.';
export const PLAN_NAME_CD_REQ = 'Plan Name is required.';
export const INVALID_DATE_FORMAT =
  'Please enter a valid date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits.';
export const ONE_EMPTY_END_DT = 'Only 1 column can have 1 empty End Date.';
export const CLIENT_ID_REQ = 'Client ID must be selected.';
export const GROUP_ID_REQ = 'Group ID must be selected.';
export const PLAN_ID_REQ = 'Plan ID must be entered.';
export const ENTER_VALID_QUARTER = 'Please give valid quarter.';

export const DATE_QTR_VALIDATION =
  'Please enter a date in MM/YEAR or MM/DD/YEAR format where year is 2 or 4 digits or a valid quarter and year in #Q## or #Q#### format. Example: 1Q98 or 4Q1997.';
export const FROM_DATE_QTR_REQUIRED = 'From Date/Qtr. is required.';
export const BEGIN_DATE_QTR_REQUIRED = 'Begin Date/Qtr. is required.';
export const TO_DATE_QTR_REQUIRED = 'To Date/Qtr. is required.';
export const START_QTR_REQUIRED = 'Start Quarter is required.';
export const END_QTR_REQUIRED = 'End Quarter is required.';
export const FROM_QTR_REQUIRED = 'From Quarter is required.';
export const TO_QTR_REQUIRED = 'To Quarter is required.';
export const TO_QTR_CANT_BE_LESS_THAN_FROM =
  'To quarter cannot be less than From Quarter.';
export const TO_DATE_CANT_BE_LESS_THAN_FROM =
  'To date cannot be less than From Date.';
export const DISPUTES_START_QTR = 'From/Start Quarter is required.';
export const END_QTR_GRATER_START_QTR_CI =
  'End Quarter should be greater than Start Quarter.';
export const WRITE_OFF_SUCCESS = 'Contract has been written off.';

export const CONTRACT_DULPICATE_ERROR =
  'The start date and End date of the Contract cannot overlap with an existing contract with the same Rebate Program code and manufacturer ID';

/** Maintain Group Error Messages */
export const PARTICIPATE_START_DATE_REWUIRED =
  'Participation Start Date is required on row';
export const END_DATE_BEFORE_START_DATE =
  'End Date is before Start Date on row';
export const START_END_DATE_OVERLAP = 'Start and End Date overlap in row';
export const UNDO_WRITE_OFF = 'Undo write off Complete.';
export const NO_RECORDS_FOUND_CONTRACT =
  'No related contracts have been found.';

export const FROZEN_INVOICE_FOR_LESS_THAN_TEN =
  'Selection range includes Frozen Invoices:';
export const FROZEN_INVOICES_GREATER_THAN_TEN =
  'Selection range includes Frozen Invoices. More than 10 problems found .';
// Suspended check
export const NO_SELECTED_ROW = 'An invoice/labeler row must be selected.';
export const NO_FOUND_INVOICE_ROW = 'No invoice found for this row.';
export const WARNING_MSG_FOR_OVER_PAYMENT =
  'This check does not represent an overpayment.';
export const WARNING_MSG_FOR_CREDIT_BALANCE =
  'This check was not created by the Allocate from Credit process nor is there a large credit balance for this Labeler.';

//  Rebate Price level
export const INVALID_QTR_ERR =
  'Please enter a valid quarter and year in “#Q##” or “#Q####” format. Example: ‘1Q98’ or ‘1Q1998’.';
export const INVALID_START_QTR_ERR =
  'Please enter a valid start quarter and year in the form #Q## or #Q####format. Example: 1Q98 or 3Q1997 for row ';
export const INVALID_END_QTR_ERR =
  'Please enter a valid end quarter and year in the form #Q## or #Q#### format. Example: 1Q98 or 3Q1997 for row ';
export const LEVEL_ID_ERR = 'Level Id is a required field for row ';
export const START_QTR_ERR = 'Start Qtr is a required field for row ';
export const LEVELID_ERR = 'Level Id is a required field for row ';
export const END_QTR_ERR = 'End Qtr is a required field.';
export const END_QTR_INVALID_RANGE =
  'End Quarter cannot be less than Start Quarter.';
export const OVERLAP_ERR_PRICE_LEVEL = (drugFamily, rpm, levelId, id) =>
  `Error!  You cannot have two overlapping pricing levels for ${drugFamily} Rebate Pricing Method: ${rpm}, Level: ${levelId} for row ${id}.`;
export const INVALID_QTR_ERR_MSG =
  'Please enter a valid quarter and year in “#Q##” or “#Q####” format. Example: ‘1Q98’ or ‘1Q1998’.';
// under Threshold Invoice
export const HANDING_CODE_REQUIRED = 'Handling code cannot be set to Null.';
export const ENTER_VALID_EMAIL_OR_CANCEL =
  'There was no email address for this contact. Please enter a valid email address or Cancel.';
export const EMAIL_ID_NOT_AVAILABLE = (value) =>
  `${value} mail id not available.`;
// generate Invoice
export const NO_CHECKED_ANY_PRINT_PAPER =
  'You must select at least one invoice in order to print.';
export const NO_CHECKED_ANY_UPLOAD_REBATE_WEB =
  'You must select at least one invoice in order to upload invoice files to RebateWeb.';
export const NO_CHECKED_ANY_CREATED_ELECTRONIC_FILE =
  'You must select at least one invoice in order to create electronic files.';
export const COMMENT_REQUIRED = 'Comment is required.';
export const INVALID_INVOICE_NUM = 'Invalid Invoice Number';
export const INVOCE_NOT_FOUND = 'Invoice Not Found: Invoice';
export const DAYS_SINCE_INVOICE = 'Days Since Invoice Distributed is required.';
export const OVERWRITE_CONTACT_FRM_FILE =
  'You cannot overwrite the contacts received from provider file.';

export const JIRA_NUMBER_ERROR = 'Star Team Number is required.';
export const PROVIDER_SUMMARY_SUCCESS_MSG =
  'Provider Review Status Updated Success.';
export const CHECKS_PAYEE_REQUIRED = 'Checks for Payee is required.';
export const BATCHES_PAYEE_REQUIRED = 'Batches for Payee is required.';
export const LOGGED_BY_REQUIRED = 'Logged By is required.';
export const CONTRACT_END_QUARTER_GRT_END_DATE =
  'The End Quarter for this Drug Family is greater than Contract End Date for Row';
// allocate Payments
export const EMPTY_INVOICE_NUMBER =
  'Enter Invoice Number to associate with the selected check.';
export const NO_ROW_SELECTED_FOR_MANUFACTURER_GRID =
  'You must select a manufacturer whose invoice can be associated with the selected check.';
export const INVOICE_NUMBER_NUMERIC = 'Invoice Number should be numeric.';
export const NO_INVOICE_NUMBER_EXIST = 'No such invoice exists.';
export const NO_SELECTED_ANY_NDC = 'Please select a valid option.';
export const NO_DATA = 'No data found for selected search inputs.';
export const MANUFACTURER_IS_REQUIRED = 'Manufacturer is required.';
export const NO_SELECTED_ANY_CHECK = 'Select check to allocate.';
export const CALCULATE_PAID_AMT_ERROR =
  'This drug has been paid by a different check.';
export const PAY_REM_ACTION_MSG =
  "You can undo this action by choosing 'Undo Group Pay Action'. However, once you save the data, it cannot be undone.";
export const UNDO_GROUP_ACTION_MSG = 'There is nothing to undo.';
export const INTEREST_PAID_THIS_CHECK =
  'Interest Paid This Check should be greater than 0.';
export const MARK_INTEREST_SETTLED =
  'Are you sure you want to Mark Interest Settled for All?';
export const PARITALLY_PAID_DRUG =
  'That drug is already paid partially on a separate check.';
export const ADD_NDC_NO_SUMMARY_ERR =
  'You cannot add drug information to a non-existent invoice!';
export const SUMMARY_GRID_MSG =
  'The remaining check amount matches the invoice and ROSI amounts. Would you like to mark all items paid in full?';
// Inv Qtr Not Paid
export const PERCENT_ALLOWED_AMOUNT_REQ_LESS_THAN_100 =
  'Percent allowed amount should be Numeric & less than 100.';
export const DATE_RANGE_INVALID =
  'Please enter the date range in MM/DD/YYYY format';
export const INVOICE_NUMBER_NOT_FROZEN =
  'This invoice is not Frozen and hence cannot be allocated.';
export const CHECK_PAYEE_CODE_INV_NUMBER_MSG =
  'The check payee code for the invoice you have just selected does not match with the check previously selected.You will now be taken to the Select Check to Allocate window to establish a new credit to allocate from.';
export const JOB_COMPLETE = 'Job Complete.';
export const FAIL_PROCESSING_REQUEST =
  'There was an error processing the request. Please retry the transaction.';
export const FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR =
  'From quarter can not be greater than to quarter';

export const SELECT_ONE_OPTION = 'View and/or validate must be selected.';
export const NO_CONTRACT_EXISTS = 'No contracts exist for this selection.';
export const CONTRACT_END_DATE_REQ =
  'End date is required for Supplemental/Commercial Contract.';
export const CHECK_NUMBER_REQUIRED = 'Check number is required.';
export const CHECK_NUMBER_VALID = 'Check number is not valid.';
export const ADJUSTMENT_REQUIRED =
  'Check all adjustment or select at least one from table.';
export const FROM_DATE_PAYMENT =
  'A date / quarter is required for this Begin Date Field.';

export const FROM_DATE_REQUIRED = 'From date is required.';
export const FROM_DATE_QUARTER_REQUIRED = 'From Date / Quarter is required.';
export const To_DATE_QUARTER_REQUIRED = 'To Date / Quarter is required.';
export const TO_DATE_REQUIRED = 'To date is required.';
export const FROM_DATE_FORMAT_ERROR =
  'Please enter from date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998.';
export const QUARTER_DATE_REQUIRED_CMS =
  'Please enter date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998.’';
export const TO_DATE_FORMAT_ERROR =
  'Please enter To date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const TO_DATE_GREATER_THAN_FROM =
  "The To date can't be less than the From date.";
export const ALREADY_EXIST_CHECK_LOG_NUM_NAV =
  'There is a ROSI/PQAS open already for this check. It has been brought to focus.';
export const ALREADY_EXIST_INVOICE_NUM_NAV =
  'This invoice is already open for a DIFFERENT CHECK. You should find & close that window before trying to allocate again. Would you like to close that window now?';
export const CAL_PAID_UNITS_FORM_PAID_AMT_ERROR =
  'This drug has been paid by a different check.';
export const INV_REC_SEQ_NUM_EQUAL_ZERO =
  "This drug hasn't been paid by any check yet!";
export const RPSN_SAME_FOR_BOTH_POSITION_ERROR =
  'The same check cannot pay the same drug on two separate rows! This functionality is only for use with multiple checks paying the same drug.';
export const DRUG_SEQ_NUM_DUPLICATE_ERROR_MSG =
  'You cannot duplicate the duplicated portion of a previously duplicated drug. Please choose the original row to duplicate.';
export const UNALLOCATED_BALANCE_ERROR_MSG =
  'that will be included in the available to allocate amount. Do you wish to add the unallocated balance?';
export const ROSI_GRID_DATA_NOT_FOUND =
  'You cannot add drug information to a non-existent invoice!';
export const NDC_NOT_MODIFIED_ERROR_MSG =
  'This NDC has not been modified. Thus, nothing to deallocate!';
export const DEALLOCATED_FIRST_ADJUST_ERROR =
  'The row should be deallocated first before making adjustments.';
export const NDC_ALTER_ROW_ERROR_MSG =
  'You may not alter data on this row. Row ';
export const NDC_ALTER_ROW_ERROR_MSG1 =
  'already contains data for this drug, invoice, and check combination.';
export const ALREADY_DRUG_PAID_FULL_ERROR_MSG =
  'That drug is already paid in full.';
export const CMS_URA_UNABLE_ERROR_MSG = 'Unable to determine CMS URA.';
export const DISCREPANCY_ALERT_ERROR_MSG =
  'The current row has discrepancies, would you like to proceed with this action?';
export const ADJUSTED_URA_EQUAL_ONE =
  "The Adjusted URA must equal '1' on an adjustment!";
export const ALLOCATE_AMT_CHECK_AMT_SAME_ERROR =
  'The Check has been fully allocated, would you like to declare the Check Allocated and close the window?';
// Allocate Payment part3
export const ALREADY_EXIST_PAYMENT_FOR_CHECK =
  'This option cannot be used as there are payments associated with this check.';
export const DISCREPANCY_FOR_NDC = 'discrepancy For NDC : 00002-1433-01 [RAUA]';

export const CONTRACT_NO_CALCULATED_URA = 'No Calculated URA.';
export const BEGIN_DATE = 'Begin Date is required.';
export const GREATER_THAN_ZERO = 'Please Enter a Value Greater than Zero.';
// PQAS
export const UPDATE_STATE_FOR_ROSI_DATA = 'updateStateForRosiData';
export const AMOUNT_PAID_TRAC_AREADY_PRESENT =
  'Amount Paid This Transaction is already present.  Are you sure you want to mark this item as Paid in Full?';
export const AMOUNT_PAID_TRAC_MARK_PAINT_FULL =
  'Data exists in this row that contradicts being Paid in Full.  Would you like to mark this item as Paid in Full anyway, and clear the other data?';
export const COMMON_MODULE_MSG_IF_AMOUNT_PAID =
  'Amount Paid is already present. Are you sure you want to mark this item as Paid in Full ?';
export const ALTER_ERROR_DUPE_MSG = (val) =>
  `You may not alter data on this row.  Row "${val}" already contains data for this drug, invoice, and check combination.`;
export const COMFORMATION_MSG_FOR_DISPUTED_UNIT =
  'Paid units and disputed units should not normally be modified for an Adjust Invoice. If you are sure this is what you want, click OK, otherwise click Cancel.';
export const RIDER_NUMBER_VALID = 'Rider number is invalid.';

export const NO_CLAIM_FOUND = 'No claims were found';
export const DO_YOU_WANT_TO_RECALCULATE_VAL =
  'Are you absolutely certain you want to clear all calculated values on this row and recalculate them?';
export const MAX_NDC_ALLOWED =
  'Maximum NDC to pass is 254, you have selected more. Would you like to continue processing the first 254?';

export const FAILED_MESSAGE_STUB_INVOICE =
  'Failed to create Stub Invoice for new RPC!';
export const SUCCESS_MESSAGE_STUB_INVOICE = 'Stub Invoice created';
export const DELETE_GROUP_WARN =
  'To delete a group there cannot be any corresponding plans.';
export const DELETE_NM_ERR =
  'This account Number has been already used for the Reports,so you cannot delete the data for the quarter ';
export const QTR_CHANGE_CONFIRMATION =
  'You must save before you can change quarters or you will lose the modifications you have made. Would you like to proceed with the quarter change and LOSE ALL MODIFICATIONS?';
export const FROM_DATE_LESS_THAN_ERROR =
  "From date can't be less than 01/01/1991.";
export const TO_DATE_GREATER_THAN_FROM_DATE =
  'To Date must be after From Date.';
export const SUPPLEMENTAL = 'SUPP';
export const NO_DRAMS_INVOICE_QUATER = (val) =>
  `No Drams invoice start quarter found for selected Rebate Program ${val}.`;
export const API_TIMEOUT_ERROR =
  'Connection Timed Out, Please try again after sometime.';
export const ONLY_NUMERIC_ALLOWED = 'Only numeric value is allowed.';
export const DEVELOPER = 'Developer';
export const NO_SELECT_PROVIDER =
  'You did not select a Provider. If you want to cancel, please press Cancel.';
export const NO_PRINTER_AVAILABLE_ERROR =
  'There is no printer selected for remote printing. Please select a default printer from System > User Default for successful remote printing.';
export const REMOTE_PRINT_FAILED_ERROR =
  'Remote printing failed. Please verify the printer IP address and try again.';
export const FREEZE_DT_REQ = 'Freeze Date is required.';
export const MINIMUM_FREEZE_DT = "Freeze Date can't be less than 01/01/1991.";
export const INVOICE_NUM_REQ = 'Invoice Number is required.';
export const MINIMUM_MAILING_DT = "Mailing Date can't be less than 01/01/1991.";
export const DUPLICATE_REMINDER_ERROR_MSG =
  'Duplicate reminders cannot be assigned to the same User ID on Row ';
export const JOB_SUBMITTED_TO_NIGHT_MSG =
  'Job will be submitted to Run Later Tonight.';
export const INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG =
  'Claims previously invoiced for provider below will be excluded';
export const INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG_1 =
  'Claims previously excluded provider below will be considered for invoicing';
export const CONTACT_ANOMALIES_NO_DATA = 'No Anomalies found';
export const SUCCESS_MEG_FREEZE_VALUE = 'A new CMS_FREEZE row is inserted.';
export const ERROR_MEG_FREEZE_VALUE =
  'Unable to insert new row into CMS FREEZE!.';
export const MANUFACTURE_ID_ALREADY_EXIT_MSG =
  'This manufacturer Id already exists.Please enter a different manufacturer Id.';
export const NO_LESS_THAN_ZERO = 'cannot be less than Zero';
export const NUM_OF_UNITS_LESS_THAN_ZERO =
  'Number of units cannot be less than zero';
export const BILLED_UNITS_ONLY_ZERO =
  'Billed units can only be changed to zero';
export const CORR_LINK_ID_ZERO_ERROR_MSG =
  'This row must be saved before comments can be added to it.';
export const INVOICE_CALCULATION_PROCEDURE_MSG =
  'Invoice Calculation has begun. Please check Procedure Result for completion.';
// data Niche Report
export const ERR_SELECT_REBATE_PROGRAM_REMOVE =
  'Atleast one Rebate Program must be selected.';
export const ERR_REBATE_PROGRAM_REMOVE = 'Nothing to remove.';
export const REBATE_PROGRAM_ALREADY_FOR_STC_NOT =
  'Rebate Program already selected.';
export const DATA_NICHE_ALREADY_EXIST_MSG =
  'Data Niche Provider file already exist in In file location. Do you want to overwrite the existing file.?';

// Ineligible CPT Codes
export const CPT_CODE_REQUIRED = 'Please enter a valid CPT Code in row #';
export const INEDIBILITY_PERIOD_BEGIN_DATE_REQ =
  'Ineligibility Period Begin Date is required in row #';
export const INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR =
  "The Ineligibility Period End Date can't be less than the Ineligibility Period Begin Date in row #";
export const MINIMUM_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR =
  "Ineligibility Period Begin Date can't be less than 01/01/1991 in row #";
export const INELIGIBLE_CPT_CODE_FROZEN_INV_MSG =
  'CPT code entry cannot be deleted; This period contains frozen invoice.';
export const INELIGIBLE_CPT_CODE_DELETE_CONF_MSG =
  'A CPT code should only be deleted if added in error. If CPT code is no longer eligible, please enter end date. Delete row';
export const NO_CLAIM_FOUND_INVOICE_AUDIT = "No claims were found matching the provided criteria."
export const INVALID_INVOICE_ERR = 'Invalid Invoice Number.';
export const INVALID_LONG_ERROR_REGEX = /Cannot deserialize value of type `java\.lang\.Long/;
export const DASH_ONLY_MSG = "Item '-' does not pass validation test."; 
export const PAID_DATE_QUARTER_REQ = 'A Paid date or quarter is required'
export const CLAIM_CCODE_REQ  ='Claim Category Code is required.'